import TaskTypes from 'src/enums/TaskTypes'

const taskTypeToIconMap = {
  [TaskTypes.WATCH_VIDEO]: 'ondemand_video',
  [TaskTypes.OPERATIONAL]: 'build_circle',
  [TaskTypes.GOVERNANCE]: 'support',
}

export default taskTypeToIconMap
